import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { login, clearError } from "../redux/authSlice";
import { useNavigate } from 'react-router-dom';
import { motion } from "framer-motion";

import {
  PageLayout,
  StepperComponent,
  ContentPanel,
  LoginForm,
  OptionsForm
} from "../components/login";

const steps = ['Login', 'Select Branch'];

export default function LoginPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [activeStep, setActiveStep] = useState(0);
  const [errorMessage, setErrorMessage] = useState('');
  const [formData, setFormData] = useState({ email: '', password: '', ddSocietyBranch: '' });
  const { loading, error, isAuthenticated } = useSelector((state) => state.auth);

  // Redirect if already authenticated
  useEffect(() => {
    if (isAuthenticated) {
      navigate('/dashboard');
    }
  }, [isAuthenticated, navigate]);

  // Clear errors when component mounts
  useEffect(() => {
    dispatch(clearError());
    setErrorMessage('');
  }, [dispatch]);

  // Clear error message when user starts typing
  const handleChange = (e) => {
    if (errorMessage) {
      setErrorMessage('');
    }
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleNext = async () => {
    // Clear any existing error messages
    setErrorMessage('');
    
    if (activeStep === 0) {
      const result = await dispatch(login({
        emailId: formData.email,
        loginPassword: formData.password,
      }));

      if (login.fulfilled.match(result)) {
        setActiveStep((prev) => prev + 1);
        setErrorMessage(''); // Clear any previous errors
      } else {
        setErrorMessage(result.payload?.message || 'Login failed. Please try again.');
      }
    } else {
      setActiveStep((prev) => prev + 1);
    }
  };

  // Reset form and error when going back to step 0
  const handleBack = () => {
    if (activeStep > 0) {
      setActiveStep((prev) => prev - 1);
      setErrorMessage('');
    }
  };

  const getImageUrl = () => {
    return activeStep === 0
      ? "/assets/images/19197510.jpg"
      : "/assets/images/19197511.jpg";
  };

  return (
    <PageLayout>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        style={{ width: '100%', maxWidth: 600 }}
      >
        <StepperComponent steps={steps} activeStep={activeStep} />
      </motion.div>
      
      <ContentPanel imageUrl={getImageUrl()}>
        <motion.div
          key={activeStep}
          initial={{ opacity: 0, x: activeStep === 0 ? -20 : 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.3 }}
          style={{ width: '100%' }}
        >
          {activeStep === 0 && (
            <LoginForm
              formData={formData}
              handleChange={handleChange}
              handleNext={handleNext}
              loading={loading}
              errorMessage={errorMessage}
            />
          )}

          {activeStep === 1 && (
            <OptionsForm onBack={handleBack} />
          )}
        </motion.div>
      </ContentPanel>
    </PageLayout>
  );
}